module.exports = __webpack_public_path__ + "img/feed_stock.e691c35a.svg";